import { Gem, GemColor, Quality, Stat } from '../Types'

export const Gems: Gem[] = [
  {
    IconName: 'inv_enchant_prismaticsphere',
    Stats: {
      [Stat.FrostResist]: 5,
      [Stat.NatureResist]: 5,
      [Stat.FireResist]: 5,
      [Stat.ShadowResist]: 5,
      [Stat.ArcaneResist]: 5,
    },
    Quality: Quality.Rare,
    Name: 'Infinite Sphere',
    Id: 34142,
    Phase: 1,
    Color: GemColor.Prismatic,
  },
  {
    IconName: 'inv_jewelcrafting_gem_38',
    Stats: {
      [Stat.HitRating]: 20,
    },
    Quality: Quality.Epic,
    Name: 'Rigid Stormjewel',
    Id: 45987,
    Phase: 1,
    Color: GemColor.Yellow,
  },
  {
    IconName: 'inv_jewelcrafting_gem_26',
    Stats: {
      [Stat.ResilienceRating]: 20,
    },
    Quality: Quality.Epic,
    Name: "Kharmaa's Grace",
    Id: 44066,
    Phase: 1,
    Color: GemColor.Yellow,
  },
  {
    IconName: 'inv_jewelcrafting_dragonseye04',
    Stats: {
      [Stat.Stamina]: 51,
    },
    Quality: Quality.Epic,
    Name: "Solid Dragon's Eye",
    Id: 36767,
    Phase: 1,
    Color: GemColor.Blue,
  },
  {
    IconName: 'inv_jewelcrafting_icediamond_02',
    Stats: {
      [Stat.CritRating]: 25,
    },
    Quality: Quality.Rare,
    Name: 'Destructive Skyflare Diamond',
    Id: 41307,
    Phase: 1,
    Color: GemColor.Meta,
  },
  {
    IconName: 'inv_jewelcrafting_icediamond_02',
    Stats: {
      [Stat.SpellPower]: 25,
    },
    Quality: Quality.Rare,
    Name: 'Ember Skyflare Diamond',
    Id: 41333,
    Phase: 1,
    Color: GemColor.Meta,
  },
  {
    IconName: 'inv_jewelcrafting_icediamond_02',
    Stats: {
      [Stat.CritRating]: 21,
    },
    Quality: Quality.Rare,
    Name: 'Enigmatic Skyflare Diamond',
    Id: 41335,
    Phase: 1,
    Color: GemColor.Meta,
  },
  {
    IconName: 'inv_jewelcrafting_icediamond_02',
    Stats: {
      [Stat.SpellPower]: 25,
    },
    Quality: Quality.Rare,
    Name: 'Tireless Skyflare Diamond',
    Id: 41375,
    Phase: 1,
    Color: GemColor.Meta,
  },
  {
    IconName: 'inv_jewelcrafting_icediamond_02',
    Stats: {
      [Stat.Mp5]: 11,
    },
    Quality: Quality.Rare,
    Name: 'Revitalizing Skyflare Diamond',
    Id: 41376,
    Phase: 1,
    Color: GemColor.Meta,
  },
  {
    IconName: 'inv_jewelcrafting_icediamond_02',
    Stats: {
      [Stat.Stamina]: 32,
    },
    Quality: Quality.Rare,
    Name: 'Effulgent Skyflare Diamond',
    Id: 41377,
    Phase: 1,
    Color: GemColor.Meta,
  },
  {
    IconName: 'inv_jewelcrafting_icediamond_02',
    Stats: {
      [Stat.SpellPower]: 25,
    },
    Quality: Quality.Rare,
    Name: 'Forlorn Skyflare Diamond',
    Id: 41378,
    Phase: 1,
    Color: GemColor.Meta,
  },
  {
    IconName: 'inv_jewelcrafting_icediamond_02',
    Stats: {
      [Stat.CritRating]: 21,
    },
    Quality: Quality.Rare,
    Name: 'Impassive Skyflare Diamond',
    Id: 41379,
    Phase: 1,
    Color: GemColor.Meta,
  },
  {
    IconName: 'inv_jewelcrafting_shadowspirit_02',
    Stats: {
      [Stat.Stamina]: 32,
    },
    Quality: Quality.Rare,
    Name: 'Austere Earthsiege Diamond',
    Id: 41380,
    Phase: 1,
    Color: GemColor.Meta,
  },
  {
    IconName: 'inv_jewelcrafting_gem_25',
    Stats: {
      [Stat.Stamina]: 12,
      [Stat.Intellect]: 8,
    },
    Quality: Quality.Rare,
    Name: 'Timeless Forest Emerald',
    Id: 40085,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_25',
    Stats: {
      [Stat.Stamina]: 12,
      [Stat.CritRating]: 8,
    },
    Quality: Quality.Rare,
    Name: 'Jagged Forest Emerald',
    Id: 40086,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_25',
    Stats: {
      [Stat.Stamina]: 12,
      [Stat.HitRating]: 8,
    },
    Quality: Quality.Rare,
    Name: 'Vivid Forest Emerald',
    Id: 40088,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_25',
    Stats: {
      [Stat.Stamina]: 12,
      [Stat.ResilienceRating]: 8,
    },
    Quality: Quality.Rare,
    Name: 'Steady Forest Emerald',
    Id: 40090,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_25',
    Stats: {
      [Stat.Stamina]: 12,
      [Stat.HasteRating]: 8,
    },
    Quality: Quality.Rare,
    Name: 'Forceful Forest Emerald',
    Id: 40091,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_25',
    Stats: {
      [Stat.Intellect]: 8,
      [Stat.Spirit]: 8,
    },
    Quality: Quality.Rare,
    Name: "Seer's Forest Emerald",
    Id: 40092,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_25',
    Stats: {
      [Stat.Intellect]: 8,
      [Stat.Mp5]: 4,
    },
    Quality: Quality.Rare,
    Name: 'Dazzling Forest Emerald',
    Id: 40094,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_25',
    Stats: {
      [Stat.Spirit]: 8,
      [Stat.CritRating]: 8,
    },
    Quality: Quality.Rare,
    Name: 'Misty Forest Emerald',
    Id: 40095,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_25',
    Stats: {
      [Stat.CritRating]: 8,
      [Stat.Mp5]: 4,
    },
    Quality: Quality.Rare,
    Name: 'Sundered Forest Emerald',
    Id: 40096,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_25',
    Stats: {
      [Stat.SpellPenetration]: 10,
      [Stat.CritRating]: 8,
    },
    Quality: Quality.Rare,
    Name: 'Radiant Forest Emerald',
    Id: 40098,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_25',
    Stats: {
      [Stat.Spirit]: 8,
      [Stat.HitRating]: 8,
    },
    Quality: Quality.Rare,
    Name: 'Shining Forest Emerald',
    Id: 40099,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_25',
    Stats: {
      [Stat.HitRating]: 8,
      [Stat.Mp5]: 4,
    },
    Quality: Quality.Rare,
    Name: 'Lambent Forest Emerald',
    Id: 40100,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_25',
    Stats: {
      [Stat.SpellPenetration]: 10,
      [Stat.HitRating]: 8,
    },
    Quality: Quality.Rare,
    Name: 'Tense Forest Emerald',
    Id: 40101,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_25',
    Stats: {
      [Stat.Spirit]: 8,
      [Stat.ResilienceRating]: 8,
    },
    Quality: Quality.Rare,
    Name: 'Turbid Forest Emerald',
    Id: 40102,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_25',
    Stats: {
      [Stat.ResilienceRating]: 8,
      [Stat.Mp5]: 4,
    },
    Quality: Quality.Rare,
    Name: 'Opaque Forest Emerald',
    Id: 40103,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_25',
    Stats: {
      [Stat.Spirit]: 8,
      [Stat.HasteRating]: 8,
    },
    Quality: Quality.Rare,
    Name: 'Intricate Forest Emerald',
    Id: 40104,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_25',
    Stats: {
      [Stat.HasteRating]: 8,
      [Stat.Mp5]: 4,
    },
    Quality: Quality.Rare,
    Name: 'Energized Forest Emerald',
    Id: 40105,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_25',
    Stats: {
      [Stat.SpellPenetration]: 10,
      [Stat.HasteRating]: 8,
    },
    Quality: Quality.Rare,
    Name: 'Shattered Forest Emerald',
    Id: 40106,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_37',
    Stats: {
      [Stat.SpellPower]: 23,
    },
    Quality: Quality.Epic,
    Name: 'Runed Cardinal Ruby',
    Id: 40113,
    Phase: 1,
    Color: GemColor.Red,
  },
  {
    IconName: 'inv_jewelcrafting_gem_42',
    Stats: {
      [Stat.Stamina]: 30,
    },
    Quality: Quality.Epic,
    Name: 'Solid Majestic Zircon',
    Id: 40119,
    Phase: 1,
    Color: GemColor.Blue,
  },
  {
    IconName: 'inv_jewelcrafting_gem_42',
    Stats: {
      [Stat.Spirit]: 20,
    },
    Quality: Quality.Epic,
    Name: 'Sparkling Majestic Zircon',
    Id: 40120,
    Phase: 1,
    Color: GemColor.Blue,
  },
  {
    IconName: 'inv_jewelcrafting_gem_42',
    Stats: {
      [Stat.Mp5]: 10,
    },
    Quality: Quality.Epic,
    Name: 'Lustrous Majestic Zircon',
    Id: 40121,
    Phase: 1,
    Color: GemColor.Blue,
  },
  {
    IconName: 'inv_jewelcrafting_gem_42',
    Stats: {
      [Stat.SpellPenetration]: 25,
    },
    Quality: Quality.Epic,
    Name: 'Stormy Majestic Zircon',
    Id: 40122,
    Phase: 1,
    Color: GemColor.Blue,
  },
  {
    IconName: 'inv_jewelcrafting_gem_38',
    Stats: {
      [Stat.Intellect]: 20,
    },
    Quality: Quality.Epic,
    Name: "Brilliant King's Amber",
    Id: 40123,
    Phase: 1,
    Color: GemColor.Yellow,
  },
  {
    IconName: 'inv_jewelcrafting_gem_38',
    Stats: {
      [Stat.CritRating]: 20,
    },
    Quality: Quality.Epic,
    Name: "Smooth King's Amber",
    Id: 40124,
    Phase: 1,
    Color: GemColor.Yellow,
  },
  {
    IconName: 'inv_jewelcrafting_gem_38',
    Stats: {
      [Stat.HitRating]: 20,
    },
    Quality: Quality.Epic,
    Name: "Rigid King's Amber",
    Id: 40125,
    Phase: 1,
    Color: GemColor.Yellow,
  },
  {
    IconName: 'inv_jewelcrafting_gem_38',
    Stats: {
      [Stat.ResilienceRating]: 20,
    },
    Quality: Quality.Epic,
    Name: "Mystic King's Amber",
    Id: 40127,
    Phase: 1,
    Color: GemColor.Yellow,
  },
  {
    IconName: 'inv_jewelcrafting_gem_38',
    Stats: {
      [Stat.HasteRating]: 20,
    },
    Quality: Quality.Epic,
    Name: "Quick King's Amber",
    Id: 40128,
    Phase: 1,
    Color: GemColor.Yellow,
  },
  {
    IconName: 'inv_jewelcrafting_gem_40',
    Stats: {
      [Stat.Stamina]: 15,
      [Stat.SpellPower]: 12,
    },
    Quality: Quality.Epic,
    Name: 'Glowing Dreadstone',
    Id: 40132,
    Phase: 1,
    Color: GemColor.Purple,
  },
  {
    IconName: 'inv_jewelcrafting_gem_40',
    Stats: {
      [Stat.Spirit]: 10,
      [Stat.SpellPower]: 12,
    },
    Quality: Quality.Epic,
    Name: 'Purified Dreadstone',
    Id: 40133,
    Phase: 1,
    Color: GemColor.Purple,
  },
  {
    IconName: 'inv_jewelcrafting_gem_40',
    Stats: {
      [Stat.SpellPower]: 12,
      [Stat.Mp5]: 5,
    },
    Quality: Quality.Epic,
    Name: 'Royal Dreadstone',
    Id: 40134,
    Phase: 1,
    Color: GemColor.Purple,
  },
  {
    IconName: 'inv_jewelcrafting_gem_40',
    Stats: {
      [Stat.SpellPower]: 12,
      [Stat.SpellPenetration]: 13,
    },
    Quality: Quality.Epic,
    Name: 'Mysterious Dreadstone',
    Id: 40135,
    Phase: 1,
    Color: GemColor.Purple,
  },
  {
    IconName: 'inv_jewelcrafting_gem_39',
    Stats: {
      [Stat.Intellect]: 10,
      [Stat.SpellPower]: 12,
    },
    Quality: Quality.Epic,
    Name: 'Luminous Ametrine',
    Id: 40151,
    Phase: 1,
    Color: GemColor.Orange,
  },
  {
    IconName: 'inv_jewelcrafting_gem_39',
    Stats: {
      [Stat.SpellPower]: 12,
      [Stat.CritRating]: 10,
    },
    Quality: Quality.Epic,
    Name: 'Potent Ametrine',
    Id: 40152,
    Phase: 1,
    Color: GemColor.Orange,
  },
  {
    IconName: 'inv_jewelcrafting_gem_39',
    Stats: {
      [Stat.SpellPower]: 12,
      [Stat.HitRating]: 10,
    },
    Quality: Quality.Epic,
    Name: 'Veiled Ametrine',
    Id: 40153,
    Phase: 1,
    Color: GemColor.Orange,
  },
  {
    IconName: 'inv_jewelcrafting_gem_39',
    Stats: {
      [Stat.SpellPower]: 12,
      [Stat.ResilienceRating]: 10,
    },
    Quality: Quality.Epic,
    Name: 'Durable Ametrine',
    Id: 40154,
    Phase: 1,
    Color: GemColor.Orange,
  },
  {
    IconName: 'inv_jewelcrafting_gem_39',
    Stats: {
      [Stat.SpellPower]: 12,
      [Stat.HasteRating]: 10,
    },
    Quality: Quality.Epic,
    Name: 'Reckless Ametrine',
    Id: 40155,
    Phase: 1,
    Color: GemColor.Orange,
  },
  {
    IconName: 'inv_jewelcrafting_gem_41',
    Stats: {
      [Stat.Stamina]: 15,
      [Stat.Intellect]: 10,
    },
    Quality: Quality.Epic,
    Name: 'Timeless Eye of Zul',
    Id: 40164,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_41',
    Stats: {
      [Stat.Stamina]: 15,
      [Stat.CritRating]: 10,
    },
    Quality: Quality.Epic,
    Name: 'Jagged Eye of Zul',
    Id: 40165,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_41',
    Stats: {
      [Stat.Stamina]: 15,
      [Stat.HitRating]: 10,
    },
    Quality: Quality.Epic,
    Name: 'Vivid Eye of Zul',
    Id: 40166,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_41',
    Stats: {
      [Stat.Stamina]: 15,
      [Stat.ResilienceRating]: 10,
    },
    Quality: Quality.Epic,
    Name: 'Steady Eye of Zul',
    Id: 40168,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_41',
    Stats: {
      [Stat.Stamina]: 15,
      [Stat.HasteRating]: 10,
    },
    Quality: Quality.Epic,
    Name: 'Forceful Eye of Zul',
    Id: 40169,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_41',
    Stats: {
      [Stat.Intellect]: 10,
      [Stat.Spirit]: 10,
    },
    Quality: Quality.Epic,
    Name: "Seer's Eye of Zul",
    Id: 40170,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_41',
    Stats: {
      [Stat.Spirit]: 10,
      [Stat.CritRating]: 10,
    },
    Quality: Quality.Epic,
    Name: 'Misty Eye of Zul',
    Id: 40171,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_41',
    Stats: {
      [Stat.Spirit]: 10,
      [Stat.HitRating]: 10,
    },
    Quality: Quality.Epic,
    Name: 'Shining Eye of Zul',
    Id: 40172,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_41',
    Stats: {
      [Stat.Spirit]: 10,
      [Stat.ResilienceRating]: 10,
    },
    Quality: Quality.Epic,
    Name: 'Turbid Eye of Zul',
    Id: 40173,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_41',
    Stats: {
      [Stat.Spirit]: 10,
      [Stat.HasteRating]: 10,
    },
    Quality: Quality.Epic,
    Name: 'Intricate Eye of Zul',
    Id: 40174,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_41',
    Stats: {
      [Stat.Intellect]: 10,
      [Stat.Mp5]: 5,
    },
    Quality: Quality.Epic,
    Name: 'Dazzling Eye of Zul',
    Id: 40175,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_41',
    Stats: {
      [Stat.CritRating]: 10,
      [Stat.Mp5]: 5,
    },
    Quality: Quality.Epic,
    Name: 'Sundered Eye of Zul',
    Id: 40176,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_41',
    Stats: {
      [Stat.HitRating]: 10,
      [Stat.Mp5]: 5,
    },
    Quality: Quality.Epic,
    Name: 'Lambent Eye of Zul',
    Id: 40177,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_41',
    Stats: {
      [Stat.ResilienceRating]: 10,
      [Stat.Mp5]: 5,
    },
    Quality: Quality.Epic,
    Name: 'Opaque Eye of Zul',
    Id: 40178,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_41',
    Stats: {
      [Stat.HasteRating]: 10,
      [Stat.Mp5]: 5,
    },
    Quality: Quality.Epic,
    Name: 'Energized Eye of Zul',
    Id: 40179,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_41',
    Stats: {
      [Stat.SpellPenetration]: 13,
      [Stat.CritRating]: 10,
    },
    Quality: Quality.Epic,
    Name: 'Radiant Eye of Zul',
    Id: 40180,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_41',
    Stats: {
      [Stat.SpellPenetration]: 13,
      [Stat.HitRating]: 10,
    },
    Quality: Quality.Epic,
    Name: 'Tense Eye of Zul',
    Id: 40181,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_41',
    Stats: {
      [Stat.SpellPenetration]: 13,
      [Stat.HasteRating]: 10,
    },
    Quality: Quality.Epic,
    Name: 'Shattered Eye of Zul',
    Id: 40182,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_dragonseye05',
    Stats: {
      [Stat.SpellPower]: 39,
    },
    Quality: Quality.Epic,
    Name: "Runed Dragon's Eye",
    Id: 42144,
    Phase: 1,
    Color: GemColor.Red,
  },
  {
    IconName: 'inv_jewelcrafting_dragonseye04',
    Stats: {
      [Stat.Spirit]: 34,
    },
    Quality: Quality.Epic,
    Name: "Sparkling Dragon's Eye",
    Id: 42145,
    Phase: 1,
    Color: GemColor.Blue,
  },
  {
    IconName: 'inv_jewelcrafting_dragonseye04',
    Stats: {
      [Stat.Mp5]: 17,
    },
    Quality: Quality.Epic,
    Name: "Lustrous Dragon's Eye",
    Id: 42146,
    Phase: 1,
    Color: GemColor.Blue,
  },
  {
    IconName: 'inv_jewelcrafting_dragonseye03',
    Stats: {
      [Stat.Intellect]: 34,
    },
    Quality: Quality.Epic,
    Name: "Brilliant Dragon's Eye",
    Id: 42148,
    Phase: 1,
    Color: GemColor.Yellow,
  },
  {
    IconName: 'inv_jewelcrafting_dragonseye03',
    Stats: {
      [Stat.CritRating]: 34,
    },
    Quality: Quality.Epic,
    Name: "Smooth Dragon's Eye",
    Id: 42149,
    Phase: 1,
    Color: GemColor.Yellow,
  },
  {
    IconName: 'inv_jewelcrafting_dragonseye03',
    Stats: {
      [Stat.HasteRating]: 34,
    },
    Quality: Quality.Epic,
    Name: "Quick Dragon's Eye",
    Id: 42150,
    Phase: 1,
    Color: GemColor.Yellow,
  },
  {
    IconName: 'inv_jewelcrafting_dragonseye04',
    Stats: {
      [Stat.SpellPenetration]: 43,
    },
    Quality: Quality.Epic,
    Name: "Stormy Dragon's Eye",
    Id: 42155,
    Phase: 1,
    Color: GemColor.Blue,
  },
  {
    IconName: 'inv_jewelcrafting_dragonseye03',
    Stats: {
      [Stat.HitRating]: 34,
    },
    Quality: Quality.Epic,
    Name: "Rigid Dragon's Eye",
    Id: 42156,
    Phase: 1,
    Color: GemColor.Yellow,
  },
  {
    IconName: 'inv_jewelcrafting_dragonseye03',
    Stats: {
      [Stat.ResilienceRating]: 34,
    },
    Quality: Quality.Epic,
    Name: "Mystic Dragon's Eye",
    Id: 42158,
    Phase: 1,
    Color: GemColor.Yellow,
  },
  {
    IconName: 'inv_jewelcrafting_gem_42',
    Stats: {
      [Stat.Stamina]: 30,
    },
    Quality: Quality.Epic,
    Name: 'Solid Stormjewel',
    Id: 45880,
    Phase: 1,
    Color: GemColor.Blue,
  },
  {
    IconName: 'inv_jewelcrafting_gem_42',
    Stats: {
      [Stat.Spirit]: 20,
    },
    Quality: Quality.Epic,
    Name: 'Sparkling Stormjewel',
    Id: 45881,
    Phase: 1,
    Color: GemColor.Blue,
  },
  {
    IconName: 'inv_jewelcrafting_gem_38',
    Stats: {
      [Stat.Intellect]: 20,
    },
    Quality: Quality.Epic,
    Name: 'Brilliant Stormjewel',
    Id: 45882,
    Phase: 1,
    Color: GemColor.Yellow,
  },
  {
    IconName: 'inv_jewelcrafting_gem_37',
    Stats: {
      [Stat.SpellPower]: 23,
    },
    Quality: Quality.Epic,
    Name: 'Runed Stormjewel',
    Id: 45883,
    Phase: 1,
    Color: GemColor.Red,
  },
  {
    IconName: 'inv_jewelcrafting_icediamond_02',
    Stats: {
      [Stat.CritRating]: 21,
    },
    Quality: Quality.Rare,
    Name: 'Chaotic Skyflare Diamond',
    Id: 41285,
    Phase: 1,
    Color: GemColor.Meta,
  },
  {
    IconName: 'inv_jewelcrafting_icediamond_02',
    Stats: {
      [Stat.SpellPower]: 20,
    },
    Quality: Quality.Rare,
    Name: 'Tireless Starflare Diamond',
    Id: 44078,
    Phase: 1,
    Color: GemColor.Meta,
  },
  {
    IconName: 'inv_jewelcrafting_icediamond_02',
    Stats: {
      [Stat.CritRating]: 17,
    },
    Quality: Quality.Rare,
    Name: 'Enigmatic Starflare Diamond',
    Id: 44081,
    Phase: 1,
    Color: GemColor.Meta,
  },
  {
    IconName: 'inv_jewelcrafting_icediamond_02',
    Stats: {
      [Stat.CritRating]: 17,
    },
    Quality: Quality.Rare,
    Name: 'Impassive Starflare Diamond',
    Id: 44082,
    Phase: 1,
    Color: GemColor.Meta,
  },
  {
    IconName: 'inv_jewelcrafting_icediamond_02',
    Stats: {
      [Stat.SpellPower]: 20,
    },
    Quality: Quality.Rare,
    Name: 'Forlorn Starflare Diamond',
    Id: 44084,
    Phase: 1,
    Color: GemColor.Meta,
  },
  {
    IconName: 'inv_jewelcrafting_shadowspirit_02',
    Stats: {
      [Stat.Stamina]: 26,
    },
    Quality: Quality.Rare,
    Name: 'Powerful Earthshatter Diamond',
    Id: 44088,
    Phase: 1,
    Color: GemColor.Meta,
  },
  {
    IconName: 'inv_jewelcrafting_shadowspirit_02',
    Stats: {
      [Stat.SpellPower]: 20,
    },
    Quality: Quality.Rare,
    Name: 'Trenchant Earthshatter Diamond',
    Id: 44089,
    Phase: 1,
    Color: GemColor.Meta,
  },
  {
    IconName: 'inv_jewelcrafting_shadowspirit_02',
    Stats: {
      [Stat.SpellPower]: 25,
    },
    Quality: Quality.Rare,
    Name: 'Trenchant Earthsiege Diamond',
    Id: 41382,
    Phase: 1,
    Color: GemColor.Meta,
  },
  {
    IconName: 'inv_jewelcrafting_shadowspirit_02',
    Stats: {
      [Stat.CritRating]: 21,
    },
    Quality: Quality.Rare,
    Name: 'Beaming Earthsiege Diamond',
    Id: 41389,
    Phase: 1,
    Color: GemColor.Meta,
  },
  {
    IconName: 'inv_jewelcrafting_shadowspirit_02',
    Stats: {
      [Stat.SpellPower]: 25,
    },
    Quality: Quality.Rare,
    Name: 'Bracing Earthsiege Diamond',
    Id: 41395,
    Phase: 1,
    Color: GemColor.Meta,
  },
  {
    IconName: 'inv_jewelcrafting_shadowspirit_02',
    Stats: {
      [Stat.Stamina]: 32,
    },
    Quality: Quality.Rare,
    Name: 'Powerful Earthsiege Diamond',
    Id: 41397,
    Phase: 1,
    Color: GemColor.Meta,
  },
  {
    IconName: 'inv_jewelcrafting_icediamond_02',
    Quality: Quality.Rare,
    Name: 'Thundering Skyflare Diamond',
    Id: 41400,
    Phase: 1,
    Color: GemColor.Meta,
  },
  {
    IconName: 'inv_jewelcrafting_shadowspirit_02',
    Stats: {
      [Stat.Intellect]: 21,
    },
    Quality: Quality.Rare,
    Name: 'Insightful Earthsiege Diamond',
    Id: 41401,
    Phase: 1,
    Color: GemColor.Meta,
  },
  {
    IconName: 'inv_jewelcrafting_gem_16',
    Stats: {
      [Stat.SpellPower]: 16,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Runed Bloodstone',
    Id: 41438,
    Phase: 1,
    Color: GemColor.Red,
  },
  {
    IconName: 'inv_jewelcrafting_gem_17',
    Stats: {
      [Stat.Mp5]: 7,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Lustrous Chalcedony',
    Id: 41440,
    Phase: 1,
    Color: GemColor.Blue,
  },
  {
    IconName: 'inv_jewelcrafting_gem_17',
    Stats: {
      [Stat.Stamina]: 21,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Solid Chalcedony',
    Id: 41441,
    Phase: 1,
    Color: GemColor.Blue,
  },
  {
    IconName: 'inv_jewelcrafting_gem_17',
    Stats: {
      [Stat.Spirit]: 14,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Sparkling Chalcedony',
    Id: 41442,
    Phase: 1,
    Color: GemColor.Blue,
  },
  {
    IconName: 'inv_jewelcrafting_gem_17',
    Stats: {
      [Stat.SpellPenetration]: 18,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Stormy Chalcedony',
    Id: 41443,
    Phase: 1,
    Color: GemColor.Blue,
  },
  {
    IconName: 'inv_jewelcrafting_gem_15',
    Stats: {
      [Stat.Intellect]: 14,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Brilliant Sun Crystal',
    Id: 41444,
    Phase: 1,
    Color: GemColor.Yellow,
  },
  {
    IconName: 'inv_jewelcrafting_gem_15',
    Stats: {
      [Stat.ResilienceRating]: 14,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Mystic Sun Crystal',
    Id: 41445,
    Phase: 1,
    Color: GemColor.Yellow,
  },
  {
    IconName: 'inv_jewelcrafting_gem_15',
    Stats: {
      [Stat.HasteRating]: 14,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Quick Sun Crystal',
    Id: 41446,
    Phase: 1,
    Color: GemColor.Yellow,
  },
  {
    IconName: 'inv_jewelcrafting_gem_15',
    Stats: {
      [Stat.HitRating]: 14,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Rigid Sun Crystal',
    Id: 41447,
    Phase: 1,
    Color: GemColor.Yellow,
  },
  {
    IconName: 'inv_jewelcrafting_gem_15',
    Stats: {
      [Stat.CritRating]: 14,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Smooth Sun Crystal',
    Id: 41448,
    Phase: 1,
    Color: GemColor.Yellow,
  },
  {
    IconName: 'inv_jewelcrafting_gem_18',
    Stats: {
      [Stat.Stamina]: 11,
      [Stat.SpellPower]: 8,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Glowing Shadow Crystal',
    Id: 41452,
    Phase: 1,
    Color: GemColor.Purple,
  },
  {
    IconName: 'inv_jewelcrafting_gem_18',
    Stats: {
      [Stat.SpellPower]: 8,
      [Stat.SpellPenetration]: 9,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Mysterious Shadow Crystal',
    Id: 41455,
    Phase: 1,
    Color: GemColor.Purple,
  },
  {
    IconName: 'inv_jewelcrafting_gem_18',
    Stats: {
      [Stat.Spirit]: 7,
      [Stat.SpellPower]: 8,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Purified Shadow Crystal',
    Id: 41457,
    Phase: 1,
    Color: GemColor.Purple,
  },
  {
    IconName: 'inv_jewelcrafting_gem_18',
    Stats: {
      [Stat.SpellPower]: 8,
      [Stat.Mp5]: 4,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Royal Shadow Crystal',
    Id: 41459,
    Phase: 1,
    Color: GemColor.Purple,
  },
  {
    IconName: 'inv_jewelcrafting_gem_13',
    Stats: {
      [Stat.Intellect]: 7,
      [Stat.Mp5]: 4,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Dazzling Dark Jade',
    Id: 41463,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_13',
    Stats: {
      [Stat.HasteRating]: 7,
      [Stat.Mp5]: 4,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Energized Dark Jade',
    Id: 41465,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_13',
    Stats: {
      [Stat.Stamina]: 11,
      [Stat.HasteRating]: 7,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Forceful Dark Jade',
    Id: 41466,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_13',
    Stats: {
      [Stat.Spirit]: 7,
      [Stat.HasteRating]: 7,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Intricate Dark Jade',
    Id: 41467,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_13',
    Stats: {
      [Stat.Stamina]: 11,
      [Stat.CritRating]: 7,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Jagged Dark Jade',
    Id: 41468,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_13',
    Stats: {
      [Stat.HitRating]: 7,
      [Stat.Mp5]: 4,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Lambent Dark Jade',
    Id: 41469,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_13',
    Stats: {
      [Stat.Spirit]: 7,
      [Stat.CritRating]: 7,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Misty Dark Jade',
    Id: 41470,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_13',
    Stats: {
      [Stat.ResilienceRating]: 7,
      [Stat.Mp5]: 4,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Opaque Dark Jade',
    Id: 41471,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_13',
    Stats: {
      [Stat.SpellPenetration]: 9,
      [Stat.CritRating]: 7,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Radiant Dark Jade',
    Id: 41472,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_13',
    Stats: {
      [Stat.Intellect]: 7,
      [Stat.Spirit]: 7,
    },
    Quality: Quality.Uncommon,
    Name: "Perfect Seer's Dark Jade",
    Id: 41473,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_13',
    Stats: {
      [Stat.SpellPenetration]: 9,
      [Stat.HasteRating]: 7,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Shattered Dark Jade',
    Id: 41474,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_13',
    Stats: {
      [Stat.Spirit]: 7,
      [Stat.HitRating]: 7,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Shining Dark Jade',
    Id: 41475,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_13',
    Stats: {
      [Stat.Stamina]: 11,
      [Stat.ResilienceRating]: 7,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Steady Dark Jade',
    Id: 41476,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_13',
    Stats: {
      [Stat.CritRating]: 7,
      [Stat.Mp5]: 4,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Sundered Dark Jade',
    Id: 41477,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_13',
    Stats: {
      [Stat.SpellPenetration]: 9,
      [Stat.HitRating]: 7,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Tense Dark Jade',
    Id: 41478,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_13',
    Stats: {
      [Stat.Stamina]: 11,
      [Stat.Intellect]: 7,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Timeless Dark Jade',
    Id: 41479,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_13',
    Stats: {
      [Stat.Spirit]: 7,
      [Stat.ResilienceRating]: 7,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Turbid Dark Jade',
    Id: 41480,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_13',
    Stats: {
      [Stat.Stamina]: 11,
      [Stat.HitRating]: 7,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Vivid Dark Jade',
    Id: 41481,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_14',
    Stats: {
      [Stat.SpellPower]: 8,
      [Stat.ResilienceRating]: 7,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Durable Huge Citrine',
    Id: 41486,
    Phase: 1,
    Color: GemColor.Orange,
  },
  {
    IconName: 'inv_jewelcrafting_gem_14',
    Stats: {
      [Stat.Intellect]: 7,
      [Stat.SpellPower]: 8,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Luminous Huge Citrine',
    Id: 41494,
    Phase: 1,
    Color: GemColor.Orange,
  },
  {
    IconName: 'inv_jewelcrafting_gem_14',
    Stats: {
      [Stat.SpellPower]: 8,
      [Stat.CritRating]: 7,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Potent Huge Citrine',
    Id: 41495,
    Phase: 1,
    Color: GemColor.Orange,
  },
  {
    IconName: 'inv_jewelcrafting_gem_14',
    Stats: {
      [Stat.SpellPower]: 8,
      [Stat.HasteRating]: 7,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Reckless Huge Citrine',
    Id: 41497,
    Phase: 1,
    Color: GemColor.Orange,
  },
  {
    IconName: 'inv_jewelcrafting_gem_14',
    Stats: {
      [Stat.SpellPower]: 8,
      [Stat.HitRating]: 7,
    },
    Quality: Quality.Uncommon,
    Name: 'Perfect Veiled Huge Citrine',
    Id: 41502,
    Phase: 1,
    Color: GemColor.Orange,
  },
  {
    IconName: 'inv_jewelcrafting_gem_22',
    Stats: {
      [Stat.SpellPower]: 14,
    },
    Quality: Quality.Uncommon,
    Name: 'Runed Bloodstone',
    Id: 39911,
    Phase: 1,
    Color: GemColor.Red,
  },
  {
    IconName: 'inv_jewelcrafting_gem_21',
    Stats: {
      [Stat.Intellect]: 12,
    },
    Quality: Quality.Uncommon,
    Name: 'Brilliant Sun Crystal',
    Id: 39912,
    Phase: 1,
    Color: GemColor.Yellow,
  },
  {
    IconName: 'inv_jewelcrafting_gem_21',
    Stats: {
      [Stat.CritRating]: 12,
    },
    Quality: Quality.Uncommon,
    Name: 'Smooth Sun Crystal',
    Id: 39914,
    Phase: 1,
    Color: GemColor.Yellow,
  },
  {
    IconName: 'inv_jewelcrafting_gem_21',
    Stats: {
      [Stat.HitRating]: 12,
    },
    Quality: Quality.Uncommon,
    Name: 'Rigid Sun Crystal',
    Id: 39915,
    Phase: 1,
    Color: GemColor.Yellow,
  },
  {
    IconName: 'inv_jewelcrafting_gem_21',
    Stats: {
      [Stat.ResilienceRating]: 12,
    },
    Quality: Quality.Uncommon,
    Name: 'Mystic Sun Crystal',
    Id: 39917,
    Phase: 1,
    Color: GemColor.Yellow,
  },
  {
    IconName: 'inv_jewelcrafting_gem_21',
    Stats: {
      [Stat.HasteRating]: 12,
    },
    Quality: Quality.Uncommon,
    Name: 'Quick Sun Crystal',
    Id: 39918,
    Phase: 1,
    Color: GemColor.Yellow,
  },
  {
    IconName: 'inv_jewelcrafting_gem_24',
    Stats: {
      [Stat.Stamina]: 18,
    },
    Quality: Quality.Uncommon,
    Name: 'Solid Chalcedony',
    Id: 39919,
    Phase: 1,
    Color: GemColor.Blue,
  },
  {
    IconName: 'inv_jewelcrafting_gem_24',
    Stats: {
      [Stat.Spirit]: 12,
    },
    Quality: Quality.Uncommon,
    Name: 'Sparkling Chalcedony',
    Id: 39920,
    Phase: 1,
    Color: GemColor.Blue,
  },
  {
    IconName: 'inv_jewelcrafting_gem_24',
    Stats: {
      [Stat.Mp5]: 6,
    },
    Quality: Quality.Uncommon,
    Name: 'Lustrous Chalcedony',
    Id: 39927,
    Phase: 1,
    Color: GemColor.Blue,
  },
  {
    IconName: 'inv_jewelcrafting_gem_24',
    Stats: {
      [Stat.SpellPenetration]: 15,
    },
    Quality: Quality.Uncommon,
    Name: 'Stormy Chalcedony',
    Id: 39932,
    Phase: 1,
    Color: GemColor.Blue,
  },
  {
    IconName: 'inv_jewelcrafting_gem_23',
    Stats: {
      [Stat.Stamina]: 9,
      [Stat.SpellPower]: 7,
    },
    Quality: Quality.Uncommon,
    Name: 'Glowing Shadow Crystal',
    Id: 39936,
    Phase: 1,
    Color: GemColor.Purple,
  },
  {
    IconName: 'inv_jewelcrafting_gem_23',
    Stats: {
      [Stat.Spirit]: 6,
      [Stat.SpellPower]: 7,
    },
    Quality: Quality.Uncommon,
    Name: 'Purified Shadow Crystal',
    Id: 39941,
    Phase: 1,
    Color: GemColor.Purple,
  },
  {
    IconName: 'inv_jewelcrafting_gem_23',
    Stats: {
      [Stat.SpellPower]: 7,
      [Stat.Mp5]: 3,
    },
    Quality: Quality.Uncommon,
    Name: 'Royal Shadow Crystal',
    Id: 39943,
    Phase: 1,
    Color: GemColor.Purple,
  },
  {
    IconName: 'inv_jewelcrafting_gem_23',
    Stats: {
      [Stat.SpellPower]: 7,
      [Stat.SpellPenetration]: 8,
    },
    Quality: Quality.Uncommon,
    Name: 'Mysterious Shadow Crystal',
    Id: 39945,
    Phase: 1,
    Color: GemColor.Purple,
  },
  {
    IconName: 'inv_jewelcrafting_gem_20',
    Stats: {
      [Stat.Intellect]: 6,
      [Stat.SpellPower]: 7,
    },
    Quality: Quality.Uncommon,
    Name: 'Luminous Huge Citrine',
    Id: 39946,
    Phase: 1,
    Color: GemColor.Orange,
  },
  {
    IconName: 'inv_jewelcrafting_gem_20',
    Stats: {
      [Stat.SpellPower]: 7,
      [Stat.CritRating]: 6,
    },
    Quality: Quality.Uncommon,
    Name: 'Potent Huge Citrine',
    Id: 39956,
    Phase: 1,
    Color: GemColor.Orange,
  },
  {
    IconName: 'inv_jewelcrafting_gem_20',
    Stats: {
      [Stat.SpellPower]: 7,
      [Stat.HitRating]: 6,
    },
    Quality: Quality.Uncommon,
    Name: 'Veiled Huge Citrine',
    Id: 39957,
    Phase: 1,
    Color: GemColor.Orange,
  },
  {
    IconName: 'inv_jewelcrafting_gem_20',
    Stats: {
      [Stat.SpellPower]: 7,
      [Stat.ResilienceRating]: 6,
    },
    Quality: Quality.Uncommon,
    Name: 'Durable Huge Citrine',
    Id: 39958,
    Phase: 1,
    Color: GemColor.Orange,
  },
  {
    IconName: 'inv_jewelcrafting_gem_20',
    Stats: {
      [Stat.SpellPower]: 7,
      [Stat.HasteRating]: 6,
    },
    Quality: Quality.Uncommon,
    Name: 'Reckless Huge Citrine',
    Id: 39959,
    Phase: 1,
    Color: GemColor.Orange,
  },
  {
    IconName: 'inv_jewelcrafting_gem_19',
    Stats: {
      [Stat.Stamina]: 9,
      [Stat.Intellect]: 6,
    },
    Quality: Quality.Uncommon,
    Name: 'Timeless Dark Jade',
    Id: 39968,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_19',
    Stats: {
      [Stat.Stamina]: 9,
      [Stat.CritRating]: 6,
    },
    Quality: Quality.Uncommon,
    Name: 'Jagged Dark Jade',
    Id: 39974,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_19',
    Stats: {
      [Stat.Stamina]: 9,
      [Stat.HitRating]: 6,
    },
    Quality: Quality.Uncommon,
    Name: 'Vivid Dark Jade',
    Id: 39975,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_19',
    Stats: {
      [Stat.Stamina]: 9,
      [Stat.ResilienceRating]: 6,
    },
    Quality: Quality.Uncommon,
    Name: 'Steady Dark Jade',
    Id: 39977,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_19',
    Stats: {
      [Stat.Stamina]: 9,
      [Stat.HasteRating]: 6,
    },
    Quality: Quality.Uncommon,
    Name: 'Forceful Dark Jade',
    Id: 39978,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_19',
    Stats: {
      [Stat.Intellect]: 6,
      [Stat.Spirit]: 6,
    },
    Quality: Quality.Uncommon,
    Name: "Seer's Dark Jade",
    Id: 39979,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_19',
    Stats: {
      [Stat.Spirit]: 6,
      [Stat.CritRating]: 6,
    },
    Quality: Quality.Uncommon,
    Name: 'Misty Dark Jade',
    Id: 39980,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_19',
    Stats: {
      [Stat.Spirit]: 6,
      [Stat.HitRating]: 6,
    },
    Quality: Quality.Uncommon,
    Name: 'Shining Dark Jade',
    Id: 39981,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_19',
    Stats: {
      [Stat.Spirit]: 6,
      [Stat.ResilienceRating]: 6,
    },
    Quality: Quality.Uncommon,
    Name: 'Turbid Dark Jade',
    Id: 39982,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_19',
    Stats: {
      [Stat.Spirit]: 6,
      [Stat.HasteRating]: 6,
    },
    Quality: Quality.Uncommon,
    Name: 'Intricate Dark Jade',
    Id: 39983,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_19',
    Stats: {
      [Stat.Intellect]: 6,
      [Stat.Mp5]: 3,
    },
    Quality: Quality.Uncommon,
    Name: 'Dazzling Dark Jade',
    Id: 39984,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_19',
    Stats: {
      [Stat.CritRating]: 6,
      [Stat.Mp5]: 3,
    },
    Quality: Quality.Uncommon,
    Name: 'Sundered Dark Jade',
    Id: 39985,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_19',
    Stats: {
      [Stat.HitRating]: 6,
      [Stat.Mp5]: 3,
    },
    Quality: Quality.Uncommon,
    Name: 'Lambent Dark Jade',
    Id: 39986,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_19',
    Stats: {
      [Stat.ResilienceRating]: 6,
      [Stat.Mp5]: 3,
    },
    Quality: Quality.Uncommon,
    Name: 'Opaque Dark Jade',
    Id: 39988,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_19',
    Stats: {
      [Stat.HasteRating]: 6,
      [Stat.Mp5]: 3,
    },
    Quality: Quality.Uncommon,
    Name: 'Energized Dark Jade',
    Id: 39989,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_19',
    Stats: {
      [Stat.SpellPenetration]: 8,
      [Stat.CritRating]: 6,
    },
    Quality: Quality.Uncommon,
    Name: 'Radiant Dark Jade',
    Id: 39990,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_19',
    Stats: {
      [Stat.SpellPenetration]: 8,
      [Stat.HitRating]: 6,
    },
    Quality: Quality.Uncommon,
    Name: 'Tense Dark Jade',
    Id: 39991,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_19',
    Stats: {
      [Stat.SpellPenetration]: 8,
      [Stat.HasteRating]: 6,
    },
    Quality: Quality.Uncommon,
    Name: 'Shattered Dark Jade',
    Id: 39992,
    Phase: 1,
    Color: GemColor.Green,
  },
  {
    IconName: 'inv_jewelcrafting_gem_28',
    Stats: {
      [Stat.SpellPower]: 19,
    },
    Quality: Quality.Rare,
    Name: 'Runed Scarlet Ruby',
    Id: 39998,
    Phase: 1,
    Color: GemColor.Red,
  },
  {
    IconName: 'inv_jewelcrafting_gem_27',
    Stats: {
      [Stat.Stamina]: 24,
    },
    Quality: Quality.Rare,
    Name: 'Solid Sky Sapphire',
    Id: 40008,
    Phase: 1,
    Color: GemColor.Blue,
  },
  {
    IconName: 'inv_jewelcrafting_gem_27',
    Stats: {
      [Stat.Spirit]: 16,
    },
    Quality: Quality.Rare,
    Name: 'Sparkling Sky Sapphire',
    Id: 40009,
    Phase: 1,
    Color: GemColor.Blue,
  },
  {
    IconName: 'inv_jewelcrafting_gem_27',
    Stats: {
      [Stat.Mp5]: 8,
    },
    Quality: Quality.Rare,
    Name: 'Lustrous Sky Sapphire',
    Id: 40010,
    Phase: 1,
    Color: GemColor.Blue,
  },
  {
    IconName: 'inv_jewelcrafting_gem_27',
    Stats: {
      [Stat.SpellPenetration]: 20,
    },
    Quality: Quality.Rare,
    Name: 'Stormy Sky Sapphire',
    Id: 40011,
    Phase: 1,
    Color: GemColor.Blue,
  },
  {
    IconName: 'inv_jewelcrafting_gem_26',
    Stats: {
      [Stat.Intellect]: 16,
    },
    Quality: Quality.Rare,
    Name: "Brilliant Autumn's Glow",
    Id: 40012,
    Phase: 1,
    Color: GemColor.Yellow,
  },
  {
    IconName: 'inv_jewelcrafting_gem_26',
    Stats: {
      [Stat.CritRating]: 16,
    },
    Quality: Quality.Rare,
    Name: "Smooth Autumn's Glow",
    Id: 40013,
    Phase: 1,
    Color: GemColor.Yellow,
  },
  {
    IconName: 'inv_jewelcrafting_gem_26',
    Stats: {
      [Stat.HitRating]: 16,
    },
    Quality: Quality.Rare,
    Name: "Rigid Autumn's Glow",
    Id: 40014,
    Phase: 1,
    Color: GemColor.Yellow,
  },
  {
    IconName: 'inv_jewelcrafting_gem_26',
    Stats: {
      [Stat.ResilienceRating]: 16,
    },
    Quality: Quality.Rare,
    Name: "Mystic Autumn's Glow",
    Id: 40016,
    Phase: 1,
    Color: GemColor.Yellow,
  },
  {
    IconName: 'inv_jewelcrafting_gem_26',
    Stats: {
      [Stat.HasteRating]: 16,
    },
    Quality: Quality.Rare,
    Name: "Quick Autumn's Glow",
    Id: 40017,
    Phase: 1,
    Color: GemColor.Yellow,
  },
  {
    IconName: 'inv_jewelcrafting_gem_29',
    Stats: {
      [Stat.Stamina]: 12,
      [Stat.SpellPower]: 9,
    },
    Quality: Quality.Rare,
    Name: 'Glowing Twilight Opal',
    Id: 40025,
    Phase: 1,
    Color: GemColor.Purple,
  },
  {
    IconName: 'inv_jewelcrafting_gem_29',
    Stats: {
      [Stat.Spirit]: 8,
      [Stat.SpellPower]: 9,
    },
    Quality: Quality.Rare,
    Name: 'Purified Twilight Opal',
    Id: 40026,
    Phase: 1,
    Color: GemColor.Purple,
  },
  {
    IconName: 'inv_jewelcrafting_gem_29',
    Stats: {
      [Stat.SpellPower]: 9,
      [Stat.Mp5]: 4,
    },
    Quality: Quality.Rare,
    Name: 'Royal Twilight Opal',
    Id: 40027,
    Phase: 1,
    Color: GemColor.Purple,
  },
  {
    IconName: 'inv_jewelcrafting_gem_29',
    Stats: {
      [Stat.SpellPower]: 9,
      [Stat.SpellPenetration]: 10,
    },
    Quality: Quality.Rare,
    Name: 'Mysterious Twilight Opal',
    Id: 40028,
    Phase: 1,
    Color: GemColor.Purple,
  },
  {
    IconName: 'inv_jewelcrafting_gem_30',
    Stats: {
      [Stat.Intellect]: 8,
      [Stat.SpellPower]: 9,
    },
    Quality: Quality.Rare,
    Name: 'Luminous Monarch Topaz',
    Id: 40047,
    Phase: 1,
    Color: GemColor.Orange,
  },
  {
    IconName: 'inv_jewelcrafting_gem_30',
    Stats: {
      [Stat.SpellPower]: 9,
      [Stat.CritRating]: 8,
    },
    Quality: Quality.Rare,
    Name: 'Potent Monarch Topaz',
    Id: 40048,
    Phase: 1,
    Color: GemColor.Orange,
  },
  {
    IconName: 'inv_jewelcrafting_gem_30',
    Stats: {
      [Stat.SpellPower]: 9,
      [Stat.HitRating]: 8,
    },
    Quality: Quality.Rare,
    Name: 'Veiled Monarch Topaz',
    Id: 40049,
    Phase: 1,
    Color: GemColor.Orange,
  },
  {
    IconName: 'inv_jewelcrafting_gem_30',
    Stats: {
      [Stat.SpellPower]: 9,
      [Stat.ResilienceRating]: 8,
    },
    Quality: Quality.Rare,
    Name: 'Durable Monarch Topaz',
    Id: 40050,
    Phase: 1,
    Color: GemColor.Orange,
  },
  {
    IconName: 'inv_jewelcrafting_gem_30',
    Stats: {
      [Stat.SpellPower]: 9,
      [Stat.HasteRating]: 8,
    },
    Quality: Quality.Rare,
    Name: 'Reckless Monarch Topaz',
    Id: 40051,
    Phase: 1,
    Color: GemColor.Orange,
  },
]
